import { DEC_TYPES, DEC_AREAS, DEC_STATUS, DEC_OWNERS, PRIORITY4, RISK_CATEGORIES, RISK_OWNERS, RISK_STATUS, REVIEW_FREQ, ACTION_STATUS, LIKELIHOOD, IMPACT, HISTORY_TYPES, asOpts } from "@/data/drOptions";

export const decisionFields = () => [
  { name: "title", label: "Decision title", type: "text", required: true, placeholder: "e.g. Confirm launch pricing structure" },
  { name: "decision_type", label: "Type", type: "select", options: asOpts(DEC_TYPES), required: true },
  { name: "area", label: "Area", type: "select", options: asOpts(DEC_AREAS), required: true },
  { name: "owner", label: "Owner", type: "select", options: asOpts(DEC_OWNERS), required: true },
  { name: "priority", label: "Priority", type: "select", options: asOpts(PRIORITY4), required: true },
  { name: "status", label: "Status", type: "select", options: asOpts(DEC_STATUS), required: true },
  { name: "deadline", label: "Decision deadline", type: "date" },
  { name: "review_date", label: "Review date", type: "date" },
  { name: "context", label: "Context", type: "textarea" },
  { name: "problem", label: "Problem or question", type: "textarea" },
  { name: "options", label: "Options considered", type: "textarea" },
  { name: "recommended_option", label: "Recommended option", type: "text" },
  { name: "contributors", label: "Contributors", type: "text" },
  { name: "expected_impact", label: "Expected impact", type: "textarea" },
  { name: "final_decision", label: "Final decision", type: "textarea" },
  { name: "reason", label: "Reason for decision", type: "textarea" },
  { name: "related_milestone", label: "Related launch milestone", type: "text" },
  { name: "related_module", label: "Related module", type: "text" },
  { name: "related_campaign", label: "Related campaign", type: "text" },
  { name: "related_investor", label: "Related investor", type: "text" },
  { name: "related_finance", label: "Related finance record", type: "text" },
  { name: "outcome", label: "Outcome or learning", type: "textarea" },
  { name: "notes", label: "Notes", type: "textarea" },
];

export const decideFields = () => [
  { name: "final_decision", label: "Final decision", type: "textarea", required: true, placeholder: "What was decided?" },
  { name: "reason", label: "Reason for decision", type: "textarea", required: true, placeholder: "Why this call?" },
];

export const historyFields = () => [
  { name: "update_type", label: "Update type", type: "select", options: asOpts(HISTORY_TYPES), required: true },
  { name: "text", label: "Update", type: "textarea", required: true },
  { name: "notes", label: "Notes", type: "textarea" },
];

export const riskFields = () => [
  { name: "title", label: "Risk title", type: "text", required: true, placeholder: "e.g. App Store approval delays launch" },
  { name: "category", label: "Category", type: "select", options: asOpts(RISK_CATEGORIES), required: true },
  { name: "owner", label: "Owner", type: "select", options: asOpts(RISK_OWNERS), required: true },
  { name: "likelihood", label: "Likelihood", type: "select", options: LIKELIHOOD, required: true },
  { name: "impact", label: "Impact", type: "select", options: IMPACT, required: true },
  { name: "status", label: "Status", type: "select", options: asOpts(RISK_STATUS), required: true },
  { name: "date_identified", label: "Date identified", type: "date" },
  { name: "target_resolution_date", label: "Target resolution date", type: "date" },
  { name: "review_frequency", label: "Review frequency", type: "select", options: asOpts(REVIEW_FREQ) },
  { name: "next_review_date", label: "Next review date", type: "date" },
  { name: "description", label: "Description", type: "textarea" },
  { name: "cause", label: "Cause", type: "textarea" },
  { name: "consequence", label: "Potential consequence", type: "textarea" },
  { name: "mitigation_plan", label: "Mitigation plan", type: "textarea" },
  { name: "contingency_plan", label: "Contingency plan", type: "textarea" },
  { name: "early_warning", label: "Early warning indicators", type: "textarea" },
  { name: "current_position", label: "Current position", type: "textarea" },
  { name: "related_milestone", label: "Related launch milestone", type: "text" },
  { name: "related_campaign", label: "Related campaign", type: "text" },
  { name: "related_finance", label: "Related finance record", type: "text" },
  { name: "notes", label: "Notes", type: "textarea" },
];

export const reviewFields = () => [
  { name: "review_date", label: "Review date", type: "date", required: true },
  { name: "current_likelihood", label: "Current likelihood", type: "select", options: LIKELIHOOD, required: true },
  { name: "current_impact", label: "Current impact", type: "select", options: IMPACT, required: true },
  { name: "current_position", label: "Current position", type: "textarea" },
  { name: "mitigation_progress", label: "Mitigation progress", type: "textarea" },
  { name: "new_actions", label: "New actions", type: "textarea" },
  { name: "next_review_date", label: "Next review date", type: "date" },
  { name: "notes", label: "Notes", type: "textarea" },
];

export const actionFields = () => [
  { name: "title", label: "Action title", type: "text", required: true },
  { name: "owner", label: "Owner", type: "select", options: asOpts(RISK_OWNERS), required: true },
  { name: "status", label: "Status", type: "select", options: asOpts(ACTION_STATUS), required: true },
  { name: "due_date", label: "Due date", type: "date" },
  { name: "description", label: "Description", type: "textarea" },
  { name: "outcome", label: "Outcome", type: "textarea" },
  { name: "notes", label: "Notes", type: "textarea" },
];
